/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconFreeRights = createReactComponent("outline", "free-rights", "IconFreeRights", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M13.867 9.75c-.246 -.48 -.708 -.769 -1.2 -.75h-1.334c-.736 0 -1.333 .67 -1.333 1.5c0 .827 .597 1.499 1.333 1.499h1.334c.736 0 1.333 .671 1.333 1.5c0 .828 -.597 1.499 -1.333 1.499h-1.334c-.492 .019 -.954 -.27 -1.2 -.75", "key": "svg-1" }], ["path", { "d": "M12 7v2", "key": "svg-2" }], ["path", { "d": "M12 15v2", "key": "svg-3" }], ["path", { "d": "M6 6l1.5 1.5", "key": "svg-4" }], ["path", { "d": "M16.5 16.5l1.5 1.5", "key": "svg-5" }]]);

export { IconFreeRights as default };
//# sourceMappingURL=IconFreeRights.mjs.map
